<template>
  <div class="funnel-container v-card">
    <div v-if="!isPdfContent" class="funnel-title-section">
      <h2>Funil cupons</h2>
      <mf-tabs-menu v-if="offerType === 'combo'" v-model="tab" :tabs="tabItems" class="my-4" />
    </div>
    <funnel-chart :metrics="metrics" :offer-type="offerType" :tab="tab" :activatable="activatable" />
    <div v-if="showExpansionButton" class="funnel-expansion">
      <mf-button
        text
        :label="`${expandFunnel ? 'Minimizar' : 'Ver'} cupons por loja`"
        :icon="`expand_${expandFunnel ? 'less' : 'more'}`"
        text-transform="none"
        color="marca-0-l40"
        @click="expandFunnel = !expandFunnel"
      />
    </div>
    <div v-if="expandFunnel" class="funnel-table">
      <funnel-table :key="`coupons-per-unit-${tab}`" :metrics="unitMetrics" :activatable="activatable" :offer-type="offerType" :tab="tab" />
    </div>
  </div>
</template>

<script>
import FunnelChart from './FunnelChart.vue'
import FunnelTable from './FunnelTable.vue'
export default {
  name: 'FunnelData',
  components: {
    FunnelChart,
    FunnelTable,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    offerType: {
      type: String,
      validator: (value) =>
        [
          'general',
          'percentage',
          'dynamic_pricing_percentage',
          'takepay',
          'combo',
          'cashback_percentage',
          'cashback_absolute',
          'points',
          'nextbuycashback',
          'dynamic_rule',
          'crosssell',
        ].includes(value),
    },
    metrics: {
      type: Object,
      default: () => {},
    },
    unitMetrics: {
      type: [Array, Object],
      default: () => [],
    },
    tabValue: {
      type: Number,
      default: 0,
    },
    activatable: {
      type: Boolean,
      default: false,
    },
    isPdfContent: {
      type: Boolean,
      default: false,
    },
    showExpansionButton: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    expandFunnel: false,
    tab: 0,
    tabItems: [
      {
        name: 'Produtos gatilho ',
        itemsLength: 0,
        haveLength: false,
      },
      {
        name: 'Produtos alvo',
        itemsLength: 0,
        haveLength: false,
      },
    ],
  }),
  mounted() {
    if (this.offerType === 'combo' && this.isPdfContent) {
      this.tab = this.tabValue
    }
  },
}
</script>

<style lang="scss" scoped>
.funnel-container {
  background: white;
  padding: 24px 16px !important;
  flex-direction: column;
  border-radius: 8px;
  display: flex;
  gap: 20px;
  margin-top: 20px;
  .funnel-title-section {
    h2 {
      color: $cinza-d10;
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
    }
  }
  .funnel-expansion {
    ::v-deep .v-btn__content {
      font-size: 14px !important;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 0.01em;

      .mf-icon {
        font-size: 18px !important;
      }
    }
  }
}
</style>
